<template>
  <div>Loading</div>
</template>

<script>
export default {
  mounted() {
    this.$store
      .dispatch("auth/logout")
      .then(() => this.$router.push({ name: "Home" }));
  }
};
</script>

<style>
</style>